module.exports = __webpack_public_path__ + "right.2raobFX1.svg";